export default __webpack_public_path__ + "media/images/sink-c29fa8b8bf1b68e324f5669a18a0d19c.jpg";